import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { LossOfUseItemsDto, UomDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-loss-of-use-items-container',
  templateUrl: './loss-of-use-items-container.component.html',
  styleUrls: ['./loss-of-use-items-container.component.scss']
})
export class LossOfUseItemsContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  lossOfUseItemss$: Observable<LossOfUseItemsDto[]>;
  measurelist$: Observable<UomDto[]>;
  loading: boolean;
  isLoadingLossOfUseItems$: Observable<boolean>;
  isLoadingUom$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingLossOfUseItems$ = this.gatwayFacade.isLoadingGateway("LossOfUseItems");
    this.isLoadingUom$ = this.gatwayFacade.isLoadingGateway("Uom");

    this.lossOfUseItemss$ = this.gatwayFacade.loadGateway("LossOfUseItems");
    this.measurelist$ = this.gatwayFacade.loadGateway("Uom");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLossOfUseItems(deletedValue: any) {
    this.gatwayFacade.remove("LossOfUseItems", deletedValue);
  }


// this method control both the create and update

  onSubmitLossOfUseItems(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.LossOfUseItemss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllLossOfUseItems = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllLossOfUseItems.push(pullData[i]);
    }
  }

// check if the addAllLossOfUseItems array is not empty, then dispatch the data to the store
   if(addAllLossOfUseItems.length > 0) {
    this.gatwayFacade.add('LossOfUseItems', addAllLossOfUseItems);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('LossOfUseItems', allUpdates, ['id']);
  }

   }

}
